import script from "./AddPhoneNumberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPhoneNumberModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPhoneNumberModal.vue?vue&type=style&index=0&id=310ac078&lang=css"

const __exports__ = script;

export default __exports__